<template>
    <div class="options sf-options row m-0">
        <div class="col-12 py-3 text-left text-dark">
            <p class="mb-0">We are no longer taking reservations for airport shuttles through our partner Shuttle Finder.<br>
              To manage an existing reservation, go to <a href="http://ShuttleFinder.com" style="color: #000; text-decoration: underline;">ShuttleFinder.com</a>, sign in at the top of the page, and follow the instructions in the My Reservations area.</p>
        </div>
    </div>
</template>

<script>
// import Datepicker from './../../datepicker'
import Datepicker from './../../datepicker'
import DatetimePicker from '../../../components/DatetimePicker'
import BootstrapToggle from '../../../components/BootstrapToggle'
import AlgoliaGoogleTypeaheadSF from '../components/AlgoliaGoogleTypeaheadSF'
import AirportDialogBox from '../components/_airportDialogBox'
import * as VueGoogleMaps from 'vue2-google-maps'

export default {
    mixins: [Datepicker],
    components: { AlgoliaGoogleTypeaheadSF, BootstrapToggle, DatetimePicker, AirportDialogBox },
    data() {
        return {
            isRoundTrip: false,
            datetime: '',
            returndatetime: '',
        }
    },

    watch: {
        isRoundTrip: function (val) {
            this.$store.dispatch('updateReturn', val)
        },
    },

    mounted() {
        Vue.use(VueGoogleMaps, { load: window.googleMapsConfig })
    },
}
</script>

<style></style>
